<div class="activation-layout">
  <div class="visual"></div>
  <div class="content">
    <img class="logo" src="../../../assets/MIV/brand/versao 1.png" alt="Control PS">
    <div class="card">
      <h1>Ativação de usuário</h1>
      <p class="intro">Olá {{ name || email }}, vamos ativar o seu cadastro.</p>

      <div class="status" *ngIf="message">{{ message }}</div>
      <div class="status error" *ngIf="error">{{ error }}</div>

      <section *ngIf="!tokenRequested">
        <p>Para continuar, solicite o token de ativação enviado para o seu e-mail.</p>
        <button type="button" (click)="requestToken()" [disabled]="loading">
          {{ loading ? 'Enviando...' : 'Solicitar token' }}
        </button>
      </section>

      <section *ngIf="tokenRequested && !passwordStep">
        <label>Código recebido por e-mail</label>
        <input type="text" maxlength="6" [(ngModel)]="token" placeholder="123456">
        <button type="button" (click)="goToPasswordStep()">Validar token</button>
      </section>

      <section *ngIf="passwordStep && !activationCompleted">
        <label>Nova senha</label>
        <input type="password" [(ngModel)]="password" placeholder="••••••">

        <label>Confirme a nova senha</label>
        <input type="password" [(ngModel)]="confirmPassword" placeholder="••••••">

        <p class="password-hint">A senha precisa ter no mínimo 8 caracteres, com letra maiúscula, minúscula e número.</p>

        <button type="button" (click)="activateAccount()" [disabled]="loading">
          {{ loading ? 'Ativando...' : 'Ativar conta' }}
        </button>
      </section>
    </div>
  </div>
</div>
